// Global components
import Vue from 'vue'
import Button from './Button'
import CloseIcon from './CloseIcon'
import Modal from './Modal'
import Version from './Version'
import Icon from './Icon'

Vue.component('w-button', Button)
Vue.component('w-close-icon', CloseIcon)
Vue.component('w-modal', Modal)
Vue.component('w-version', Version)
Vue.component('w-icon', Icon)
